<template>
    <el-dialog
    :visible.sync="isOpen"
    :modal-append-to-body="false"
    class="peiso-modal automated-report"
    :close-on-click-modal='false'
    width="1000px"
    :before-close="handleClose"
    center>
        <div class="header-container">
            <span>AUTOMATED REPORTS SETTING</span>
        </div>
        <div class="body-container">
            <div class="periodic-container">
                <el-tabs v-model="activeTab" :stretch="true" @tab-click="handleActiveTab">
                    <!-- <el-tab-pane label="PERIODIC SCHEDULE" name="periodic">
                    </el-tab-pane> -->
                    <el-tab-pane label="TRIGGER POINT SCHEDULE" name="trigger">
                    </el-tab-pane>
                </el-tabs>

                <div class="mt-3">
                    <span v-if="activeTab != 'periodic'" class="d-block title">SET A {{ activeTab == 'periodic' ? 'PERIODIC' : 'TRIGGER POINT' }} SCHEDULE</span>
                        <table v-if="activeTab != 'periodic'">
                            <tr v-for="(item, i) in periodicLists" :key="i">
                                <td>{{ i + 1 }}</td>
                                <td>
                                    <template v-if="item.isEdit">
                                        <el-input type="text" v-model="item.periodic" class="peiso-input-default" :class="{'is-error' : name == ''}" clearable />
                                    </template>
                                    <template v-else>
                                        {{ item.periodic }}
                                    </template>

                                </td>
                                <td>
                                    <template v-if="item.isEdit">
                                        <div class="d-flex flex-row gap-10">
                                            <el-dropdown trigger="click" class="w-100">
                                                <el-button type="peiso-default" class="w-100">
                                                    {{ item.selectedHr }}
                                                    <div class="img-container">
                                                        <img src="@/assets/arrow-down.svg" alt="">
                                                    </div>
                                                </el-button>
                                                <template #dropdown>
                                                    <el-dropdown-menu>
                                                    <el-dropdown-item v-for="(item, j) in periodicData" :key="j" @click.native="selectEditPeriodic(item, i, 'hour')">
                                                        {{ item }}
                                                    </el-dropdown-item>
                                                    </el-dropdown-menu>
                                                </template>
                                            </el-dropdown>

                                            <el-dropdown trigger="click" class="w-100">
                                                <el-button type="peiso-default" class="w-100">
                                                    {{ item.selectedMin }}
                                                    <div class="img-container">
                                                        <img src="@/assets/arrow-down.svg" alt="">
                                                    </div>
                                                </el-button>
                                                <template #dropdown>
                                                    <el-dropdown-menu>
                                                    <el-dropdown-item v-for="(item, j) in periodicMinutes" :key="j" @click.native="selectEditPeriodic(item, i, 'minute')">
                                                        {{ item }}
                                                    </el-dropdown-item>
                                                    </el-dropdown-menu>
                                                </template>
                                            </el-dropdown>
                                        </div>
                                    </template>
                                    <template v-else>
                                        {{ item.periodicTime }}
                                    </template>

                                </td>
                                <td>
                                    <div class="periodic-btns">
                                        <el-button v-if="!item.isEdit" type="peiso-primary" icon="el-icon-setting" @click="editPeriodic(i)">EDIT</el-button>
                                        <el-button v-else type="peiso-success" icon="el-icon-setting" @click="savePeriodic(item, i)">SAVE</el-button>
                                        <el-button  type="peiso-danger" class="" @click="removePeriods(item, i)" icon="el-icon-setting">DELETE</el-button>
                                    </div>

                                </td>
                            </tr>

                            <tr v-if="periodicLists.length < 5">
                                <td>-</td>
                                <td>
                                    <el-input type="text" v-model="name" class="peiso-input-default" :class="{'is-error' : name == ''}" clearable />
                                </td>
                                <td class="px-5">

                                    <div class="d-flex flex-row gap-10">
                                        <el-dropdown trigger="click" class="w-100">
                                            <el-button type="peiso-default" class="w-100">
                                                {{ selectedHr }}
                                                <div class="img-container">
                                                    <img src="@/assets/arrow-down.svg" alt="">
                                                </div>
                                            </el-button>
                                            <template #dropdown>
                                                <el-dropdown-menu>
                                                <el-dropdown-item v-for="(item, i) in periodicData" :key="i" @click.native="selectPeriodic(item, i, 'hour')">
                                                    {{ item }}
                                                </el-dropdown-item>
                                                </el-dropdown-menu>
                                            </template>
                                        </el-dropdown>

                                        <el-dropdown trigger="click" class="w-100">
                                            <el-button type="peiso-default" class="w-100">
                                                {{ selectedMinutes }}
                                                <div class="img-container">
                                                    <img src="@/assets/arrow-down.svg" alt="">
                                                </div>
                                            </el-button>
                                            <template #dropdown>
                                                <el-dropdown-menu>
                                                <el-dropdown-item v-for="(item, i) in periodicMinutes" :key="i" @click.native="selectPeriodic(item, i, 'minute')">
                                                    {{ item }}
                                                </el-dropdown-item>
                                                </el-dropdown-menu>
                                            </template>
                                        </el-dropdown>
                                    </div>

                                </td>
                                <td>
                                    <el-button type="peiso-success" icon="el-icon-setting" class="w-100" @click="setPeriodics('periodic')">SET {{activeTab == 'periodic' ? 'PERIODIC' : 'TRIGGER POINT'}}</el-button>
                                </td>
                            </tr>
                        </table>
                </div>
            </div>




            <div class="periodic-container">
                <span class="d-block title">SET AN EMAIL ADDRESS</span>

                <table class="email">
                    <tr v-for="(item, i) in emailLists" :key="i">
                        <td>{{ i + 1 }}</td>
                        <td>{{ item.email }}</td>
                        <td v-if="activeTab == 'trigger'" class="tickboxWith">
                            <div class="peiso-checkbox">
                                <el-checkbox v-model="item.trigger" @change="changeOption">Trigger</el-checkbox>
                            </div>
                        </td>
                        <td v-else class="tickboxWith">
                            <div class="peiso-checkbox">
                                <el-checkbox v-model="item.periodic" @change="changeOption">Periodic</el-checkbox>
                            </div>
                        </td>
                        <td class="tickboxWith">
                            <div class="peiso-checkbox">
                                <el-checkbox v-model="item.eod" @change="changeOption">EOD</el-checkbox>
                            </div>
                        </td>
                         <td class="tickboxWith">
                            <div class="peiso-checkbox">
                                <el-checkbox v-model="item.eos" @change="changeOption">EOS</el-checkbox>
                            </div>
                        </td>
                        <td v-if="isEnableExecutive == '1'" class="tickboxWith">
                            <div class="peiso-checkbox">
                                <el-checkbox v-model="item.eodExec" @change="changeOption">Executive</el-checkbox>
                            </div>
                        </td>
                        <td class="tickboxWith" v-if="isCashUpHide == '1'">
                            <div class="peiso-checkbox">
                                <el-tooltip v-if="!isCashUpActivated" class="item" effect="dark" content="The cashup is disabled for this venue." placement="top">
                                    <el-checkbox v-model="item.cashup" :disabled="!isCashUpActivated">Cashup</el-checkbox>
                                </el-tooltip>
                                <el-checkbox v-else v-model="item.cashup" @change="changeOption">Cashup</el-checkbox>
                            </div>
                        </td>
                        <td>
                            <el-button type="peiso-danger" icon="el-icon-setting" class="w-100" @click="removeEmail(i)">DELETE</el-button>
                        </td>
                    </tr>

                    <tr v-if="emailLists.length < maxAutomatedEmails">
                        <td>{{ this.emailLists.length + 1 }}</td>
                        <td>
                            <el-input type="email" v-model="email" class="peiso-input-default" :class="{'is-error' : email == ''}" placeholder="Please input email address" clearable />
                        </td>
                        <td v-if="activeTab == 'trigger'" class="tickboxWith">
                            <div class="peiso-checkbox">
                                <el-checkbox v-model="trigger">Trigger</el-checkbox>
                            </div>
                        </td>
                        <td v-else class="tickboxWith">
                            <div class="peiso-checkbox">
                                <el-checkbox v-model="periodic">Periodic</el-checkbox>
                            </div>
                        </td>
                        <td class="tickboxWith">
                            <div class="peiso-checkbox">
                                <el-checkbox v-model="eod">EOD</el-checkbox>
                            </div>
                        </td>
                        <td class="tickboxWith">
                            <div class="peiso-checkbox">
                                <el-checkbox v-model="eos">EOS</el-checkbox>
                            </div>
                        </td>
                        <td v-if="isEnableExecutive == '1'" class="tickboxWith">
                            <div class="peiso-checkbox">
                                <el-checkbox v-model="eodExec">Executive</el-checkbox>
                            </div>
                        </td>
                        <td class="tickboxWith" v-if="isCashUpHide == '1'">
                            <div class="peiso-checkbox">
                                <el-tooltip v-if="!isCashUpActivated" class="item" effect="dark" content="The cashup is disabled for this venue." placement="top">
                                    <el-checkbox v-model="cashup" :disabled="!isCashUpActivated">Cashup</el-checkbox>
                                </el-tooltip>
                                <el-checkbox v-else v-model="cashup">Cashup</el-checkbox>
                            </div>
                        </td>
                        <td>
                            <el-button type="peiso-success" icon="el-icon-setting" :disabled="email == ''" class="w-100" @click="setEmail">ADD EMAIL</el-button>
                        </td>
                    </tr>
                </table>

                <div class="footer">
                    Total of <span>{{ emailLists.length }} out of {{ maxAutomatedEmails }}</span> added emails
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<style lang='scss' >
    .periodic-btns {
        display: flex;
        align-items: center;
    }
    .tickboxWith {
        width: 70px !important;
        padding: 5px !important;

        .peiso-checkbox .el-checkbox__input>.el-checkbox__inner {
            height: 20px !important;
            width: 20px !important;
            background-color: var(--background-color-2) !important;
            border: 1px solid #5F5F5F !important;
        }

        .peiso-checkbox .el-checkbox__input.is-disabled>.el-checkbox__inner {
            height: 20px !important;
            width: 20px !important;
            background-color: #5F5F5F !important;
            border: 1px solid #5F5F5F !important;
        }

        .peiso-checkbox .el-checkbox__input.is-checked>.el-checkbox__inner {
            height: 20px !important;
            width: 20px !important;
            background-color: #EA3796 !important;
            border: 1px solid #EA3796 !important;
        }

        .peiso-checkbox .el-checkbox {
            flex-direction: column-reverse;
            justify-items: center;
            align-items: center;
            gap: 8px !important;
        }
    }

    .peiso-checkbox .el-checkbox {
        gap: 10px;
    }

    .el-tooltip__popper.is-dark {
        background-color: #EA3796 !important;
        margin-left: 0px !important;
    }



    .el-checkbox__label {
        font-size: 13px !important;
        padding: 0px !important;
    }
    .automated-report {
        .el-dialog {
            min-height: 450px;
        }

        .el-dropdown {
            .el-button--peiso-default {
                justify-content: start !important;
                padding-left: 1rem;
            }
        }


        .h-35 {
            height: 35px !important;
        }

        .el-tabs__item {
            color: var(--text-color);
            font-size: 20px;
            font-weight: 600;
            &:hover {
                color: #ffffffd0;
            }
        }


        .el-tabs__item.is-active {
            color: #EA3796;
        }

        .el-tabs__active-bar {
            background-color: #EA3796;
        }

        .el-tabs__header {
            margin: 0 0 45px !important;
        }
    }
</style>

<script>
    import api from '../../api/api';
    import utils from '@/utils/utils';
    import { env } from '../../env';
    
    export default {
        data() {
            return {
                periodicData: [],
                activeTab: 'trigger',
                selectPeriodicName: ['', 'BREAKFAST', 'LUNCH', 'DINNER'],
                periodicMinutes: [
                    '00', '30'
                ],

                periodic: '',
                email: '',
                eod: false,
                eos: false,
                eodExec: false,
                cashup: false,
                periodic: true,
                trigger: false,
                isCashUpActivated: false,
                periodicLists: [],
                triggerList: [],
                emailLists: [],
                isOpen: false,
                lastSelectedIdx: 0,
                selectedIdx: null,
                selectedHr: '00',
                selectedMinutes: '00',
                selecteTriggerdHr: '00',
                selectedTriggerMinutes: '00',
                triggerName: '',
                name: '',
                env,
			    isCashUpHide: process.env.IS_ENABLE_CASHUP,
                isEnableExecutive: process.env.IS_ENABLE_EXECUTIVE_EOD,
            }
        },
        props: {
            value: { default: false },
            maxAutomatedEmails: { default: null }
        },
        watch: {
            value(val) {
                this.isOpen = val
                if (val) {
                    this.getAutomatedReport()
                    this.getPeriodicSchedules();
                }
            },
            activeTab() {
                this.getPeriodicSchedules();

                this.periodic = this.activeTab == 'periodic' ?  true : false;
                this.trigger = this.activeTab == 'trigger' ?  true : false;
            },
        },
        computed: {
            periodicName() {
                var period = ''
                var periodicCount = this.periodicLists.length

                if (!periodicCount) {
                    period = 'BREAKFAST'
                } else if (periodicCount == 1) {
                    period = 'LUNCH'
                } else if (periodicCount >= 2) {
                    period = 'DINNER'
                }

                return period
            },
        },
        methods: {
            handleActiveTab() {

            },

            selectPeriodic(item, i, type) {

                // this.periodic = item
                // this.selectedIdx = i

                if (type == 'hour') {
                    this.selectedHr = item
                } else if (type == 'name') {
                    this.name = item;
                } else {
                    this.selectedMinutes = item
                }
            },

            changeOption() {
                this.setAutomatedReport()
            },

            async setPeriodics() {
                if (!this.name || this.name == '') {
                    utils.alert2('', 'Please input Name', 'error')
                    return;
                }

                if (!this.selectedMinutes || this.selectedMinutes == '') {
                    utils.alert2('', 'Please input Minutes', 'error')
                    return;
                }

                if (!this.selectedHr || this.selectedHr == '') {
                    utils.alert2('', 'Please input Hours', 'error')
                    return;
                }

                let nameExists = this.periodicLists.filter(item => item.periodic == this.name);

                if (nameExists.length > 0) {
                    utils.alert2('', 'Name already exists', 'error')
                    return;
                }

                var data = {
                    periodic: this.name,
                    periodicTime: `${this.selectedHr}:${this.selectedMinutes}`,
                    selectedMin: this.selectedMinutes,
                    selectedHr: this.selectedHr,
                    oldSched: "",
                    newSched: `${this.selectedHr}:${this.selectedMinutes}`,
                    isEdit: false,
                    isTrigger: this.activeTab == 'trigger' ? 1 : 0
                }



                const res = await this.saveAutomatedReportPeriodic ({
                    name: this.name,
                    oldSched: "",
                    newSched: `${this.selectedHr}:${this.selectedMinutes}`,
                    isTrigger: this.activeTab == 'trigger' ? 1 : 0
                }, 'create');

                if (res) {
                    this.periodicLists.push(data)
                    this.selectedHr = '';
                    this.selectedMinutes = '';
                    this.name = '';
                }



                // this.setAutomatedReport()
            },

            async saveAutomatedReportPeriodic (data, type) {
                try {

                    const res = await api.saveSchedule(data);

                    if (res.data.code === 0) {
                        if (type == 'create') {
                            utils.alert2('', 'Added Successfully.', 'success')
                        } else {
                            utils.alert2('', 'Saved Successfully.', 'success')
                        }

                        this.getPeriodicSchedules();

                        return true
                    } else {
                        utils.alert2('', res.data.message, 'error')
                        return false
                    }

                } catch (error) {
                    utils.alert2('', 'Something went wrong, please contact administrator.', 'error')
                }

                return false

            },

            setEmail() {
                if (this.email == '') {
                    return
                }
                var data = {
                    email: this.email,
                    eod: this.eod,
                    eodExec: this.eodExec,
                    cashup: this.cashup,
                    eos: this.eos,
                    periodic: this.periodic,
                    trigger: this.trigger,
                }

                this.emailLists.push(data)

                this.email = '';
                this.eod = false;
                this.eodExec = false
                this.cashup = false;
                this.eos = false;
                this.periodic = this.activeTab == 'periodic' ?  true : false;
                this.trigger = this.activeTab == 'trigger' ?  true : false;

                this.setAutomatedReport()
            },

            handleClose() {
                this.isOpen = false
                this.$emit('close-modal')
            },

            removeEmail(idx) {
                this.emailLists.splice(idx, 1)
                this.setAutomatedReport()
            },

            editPeriodic(i) {
                this.periodicLists = this.periodicLists.map((data, index) => i == index ? {...data, isEdit: true} : data)
            },

            selectEditPeriodic(item, i, type){
                if (type == 'hour') {
                    this.periodicLists = this.periodicLists.map((data, index) => i == index ? {
                        ...data,
                        selectedHr: item,
                        periodicTime: `${item}:${data.selectedMin}`,
                        newSched:  `${item}:${data.selectedMin}`,
                    } : data)
                } else if (type == 'name') {
                    this.periodicLists = this.periodicLists.map((data, index) => i == index ? {
                        ...data,
                        periodic: item,
                    } : data)
                } else {
                    this.periodicLists = this.periodicLists.map((data, index) => i == index ? {
                        ...data,
                        selectedMin: item,
                        periodicTime: `${data.selectedHr}:${item}`,
                        newSched:  `${data.selectedHr}:${item}`,
                    } : data)

                }
            },

            async savePeriodic(item, i) {
                const nameExists = this.periodicLists.filter(data => data.periodic == item.periodic);

                if (nameExists.length > 1) {
                    utils.alert2('', 'Periodic name already exists', 'error')
                    return;
                }

                this.periodicLists = this.periodicLists.map((data, index) => i == index ? {...data, isEdit: false} : data)
                console.log('update: ', {
                    name: item.periodic,
                    oldSched: item.oldSched,
                    newSched: item.newSched ? item.newSched : item.oldSched,
                });

                await this.saveAutomatedReportPeriodic ({
                    name: item.periodic,
                    oldSched: item.oldSched,
                    newSched: item.newSched ? item.newSched : item.oldSched,
                }, 'update');

            },

            async removePeriods(item, idx) {
                this.periodicLists.splice(idx ,1)

                try {
                    console.log('delete: ', {
                        name: item.periodic,
                        oldSched: item.oldSched,
                        newSched: "",
                    });
                    api.deleteSchedule({
                        name: item.periodic,
                        oldSched: item.oldSched,
                        newSched: "",
                        isTrigger: item.isTrigger,
                    });
                    utils.alert2('', 'Deleted Successfully.', 'success')

                } catch (error) {
                    utils.alert2('', 'Something went wrong, please contact administrator.', 'error')
                }


                // var periodicTime = this.periodicLists[idx - 1].periodicTime

                // var periodic = this.periodicData.indexOf(periodicTime)
                // this.lastSelectedIdx = periodic
                // this.setAutomatedReport()
            },

            defaultSelectedIdx() {
                var cnt = this.periodicLists.length
                if (cnt) {

                    var periodicTime = this.periodicLists[cnt - 1].periodicTime

                    var periodic = this.periodicData.indexOf(periodicTime)
                    this.lastSelectedIdx = periodic
                } else {
                    this.lastSelectedIdx = 0
                }
            },

            getPeriodicSchedules() {
                api.getSchedules().then(res => {
                    const data = res.data.data
                    let list = data.filter(item => (!item.isTrigger || item.isTrigger == 0));

                    if (this.activeTab == 'trigger') {
                        list = data.filter(item => (item.isTrigger && item.isTrigger == 1));
                    }

                    this.periodicLists = list.map(item => {
                        const hr = item.schedule.split(':');

                        var isPastMidnight = 0
                        if (hr[0] == '00' || hr[0] == '01' || hr[0] == '02' || hr[0] == '03' || hr[0] == '04' || hr[0] == '05') {
                            isPastMidnight = 1
                        }

                        return {
                            periodic: item.name, // change dynamically
                            periodicTime: item.schedule,
                            selectedMin:  hr[1],
                            selectedHr: hr[0],
                            isDeleteEnable: true,
                            isEdit: false,
                            oldSched: item.schedule,
                            newSched: "",
                            isTrigger: item.isTrigger && item.isTrigger == 1 ?  1 : 0,
                            isPastMidnight: isPastMidnight
                        }
                    })

                    this.periodicLists = this.periodicLists.sort((a, b) => a.isPastMidnight - b.isPastMidnight)
                    console.log(this.periodicLists, 'this.periodicLists')
                })
            },

            getAutomatedReport() {
                var periodic = ['', 'BREAKFAST', 'LUNCH', 'DINNER']
                api.getAutomatedReport().then((res) => {
                    var data = res.data.data
                    console.log('data: ', data);
                    // var i = 0
                    // var cnt = data.periods.length
                    // var resPeriodic = data.periods.map((res) => {
                    //     var hr = res.split(':')
                    //     i = i + 1
                    //     var n = {
                    //         periodic: utils.getPeriodName(parseInt(hr[0])), // change dynamically
                    //         periodicTime: res,
                    //         selectedMin:  hr[1],
                    //         selectedHr: hr[0],
                    //         isDeleteEnable: i == cnt ? true : false,
                    //         isEdit: false,
                    //         oldSched: res,
                    //         newSched: ""
                    //     }

                    //     return n
                    // })

                    var resEmail = data.emailAddresses.map((res) => {
                        var n = {
                            email: res.email,
                            eod: res.eod == 1 ? true :  false,
                            eodExec: res.eodExec == 1 ? true : false,
                            cashup: res.cashup == 1 ? true : false,
                            periodic: res.periodic == 1 ? true : false,
                            trigger: res.triggers == 1 ? true : false,
                            eos: (res.eos && res.eos == 1) ? true : false
                        }
                        return n
                    })

                    // this.periodicLists = resPeriodic
                    this.emailLists = resEmail

                    // this.defaultSelectedIdx()
                    this.getLastTime('00:00')
                    // this.name = this.periodicName
                })
            },

            setAutomatedReport() {
                var getPeriodicTime = this.periodicLists.map((res) => {
                    return res.periodicTime
                })

                // var getPeriodicTime = [];

                var getEmail = this.emailLists.map((res) => {
                    return {
                        email: res.email,
                        eod: res.eod ? 1 : 0,
                        eodExec: res.eodExec ? 1 : 0,
                        cashup: res.cashup ? 1 : 0,
                        periodic: res.periodic ? 1 : 0,
                        triggers: res.trigger ? 1 : 0,
                        eos: res.eos ? 1 : 0
                    }
                })

                // var getEmail = this.emailLists;

                api.setAutomatedReport({periods: getPeriodicTime, emailAddresses: getEmail}).then((res) => {
                    this.getAutomatedReport()
                })
            },

            async getLastTime(time = '00:00') {
                this.periodicData  = [
                    "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18",
                    "19", "20", "21", "22",  "23", "00"
                ]

                var res = await api.getVenueInfoForPeriodic()
                var openingList = res.data.data.venueOpenList.filter((n) => n.openTime != 'Closed')

                // if (utils.checkPastmidnight(openingList)) {
                //     this.periodicData = [...this.periodicData, "01", "02", "03", "04", "05"]
                // }

                this.periodicData = [...this.periodicData, "01", "02", "03", "04", "05"]

                time = time.split(':')
                var hour = time[0]

                // this.periodicData = this.periodicData.filter((n) => parseInt(n) > parseInt(hour))
                this.selectedHr = this.periodicData[0]
                this.selectedMinutes = this.periodicMinutes[0]

            },


        },

        mounted() {
            api.progress('', (res) => {
                if (res.data.code == 0) {
                    const data = res.data.data
                    this.isCashUpActivated = (data.isCashUpActivated == 1)
                }

            });
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/modal/dialog.vue